import { Box, Button, useMediaQuery, useTheme } from "@mui/material";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import React, { useEffect, useRef, useState } from "react";
import {
  ExpensesIcon,
  FIlterIcon,
  IncomeIcon,
  NetProfit,
  RefreshIcon,
  UpdateIcon,
} from "../../assets/Icon/headerCicon";
import BookkeeperCard from "./components/BookkeeperCard";
import BookkeeperTable from "./components/BookkeeperTable";
import BookkeeperBalanceSheet from "./components/BookkeeperBalanceSheet";
import { useDispatch } from "react-redux";
import {
  disconnectBank,
  fetchASync,
  flagBanks,
  getBanksLists,
  getLinkBankToken,
  getTransactionsStatus,
  getTransactionsTableData,
  reconnectBank,
  updateLinkBankToken,
  userExchangeToken,
} from "../../stores/clients";
import { setToast } from "../../stores/toast/toastslice";
import { useNavigate } from "react-router-dom";
import ListLoadingNew from "../common-components/ListLoadingNew";
import {
  AddBankIcon,
  BankBlueIcon,
  ReconnectBankIcon,
} from "../../assets/Icon/dashboredIcon";
import ConnectionDropdown from "../common-components/ConnectionDropdown";
import { DownArrowIcon } from "../../assets/Icon/ArrowIcon";
import { CrossIcon, ModalBottom, ModalTop } from "../../assets/Icon/ModalIcon";
import {
  ModalWrapper,
  CloseButton,
  CloseButtonWrapper,
} from "../style/modalStyle";
import Modal from "@mui/material/Modal";
import { usePlaidLink } from "react-plaid-link";

interface TabPanelProps {
  children?: React.ReactNode;
  index: number;
  value: number;
}

interface BookkeeperDataProps {
  net_amount: number;
  total_received: number;
  total_paid: number;
}

function CustomTabPanel(props: TabPanelProps) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && <Box sx={{ py: 3 }}>{children}</Box>}
    </div>
  );
}

function a11yProps(index: number) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}

const BookkeeperData = () => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));
  const isTablet = useMediaQuery(theme.breakpoints.between("md", "lg"));
  const [value, setValue] = React.useState(0);
  const [data, setData] = useState<BookkeeperDataProps | null>(null);
  const [isFetching, setIsFetching] = useState(false);
  const [loading, setLoading] = useState(true);
  const [isDelete, setIsDelete] = useState(false);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const filterRef = useRef<HTMLDivElement>(null);
  const [filterOpen, setFilterOpen] = useState(false);
  const [openCategoryModal, setopenCategoryModal] = useState(false);
  const [openReconnectModal, setopenReconnectModal] = useState(false);
  const [banks, setBanks] = useState<any>();
  const [linkToken, setLinkToken] = useState<any>(null);
  const [selectedBank, setSelectedBank] = useState<any>(null);
  const [reAuthBanks, setReAuthBanks] = useState<any>([]);
  const [reAuthToken, setReAuthToken] = useState<any>(null);
  const [addbankLoading, setAddbankLoading] = useState(false);
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);

  const [shouldOpenPlaid, setShouldOpenPlaid] = useState(false);

  const handleDisconnect = async () => {
    console.log("Disconnect clicked:", selectedBank);
    setopenCategoryModal(true);
    await dispatch<any>(disconnectBank({ bankId: selectedBank?.id })).unwrap();
    // refetch banks list
    await dispatch<any>(getBanksLists()).then((res: any) => {
      setBanks(res?.payload?.data);
    });
    await dispatch<any>(
      setToast({
        message: `${selectedBank?.institution_name} disconnected successfully!`,
        type: "success",
        title: "Success",
        onClose: () => {},
      })
    );
    setopenCategoryModal(false);
    setFilterOpen(false);
  };

  const handleReconnect = async (bank?: any, fromPopup = false) => {
    console.log(bank, "bank");
    if (bank?.needs_reauth || fromPopup) {
      await dispatch<any>(
        updateLinkBankToken({ id: bank?.id || bank?.plaid_item_id })
      ).then((res: any) => {
        setReAuthToken(res?.payload?.link_token);
        // setopenReconnectModal(false);
        return;
      });
    } else {
      // call API to reconnect
      await dispatch<any>(reconnectBank({ bankId: bank?.id }));
      // refetch banks list
      await dispatch<any>(getBanksLists()).then((res: any) => {
        setBanks(res?.payload?.data);
      });
      await dispatch<any>(
        setToast({
          message: `Bank connected successfully!`,
          type: "success",
          title: "Success",
          onClose: () => {},
        })
      );
      return;
    }
  };

  // Handle Plaid Link success
  const handleClick = async (e: any) => {
    e.preventDefault(); // Prevent any default behavior
    // Set a flag to prevent multiple clicks
    setAddbankLoading(true);
    if (ready && linkToken) {
      setTimeout(() => {
        open();
      }, 1000);
    }
  };

  useEffect(() => {
    const transcationData = async () => {
      try {
        const res = await dispatch<any>(getTransactionsStatus()).unwrap();
        await dispatch<any>(getBanksLists()).then((res: any) => {
          setBanks(res?.payload?.data);
        });
        await dispatch<any>(getLinkBankToken()).then((res: any) => {
          setLinkToken(res?.payload?.link_token);
          console.log(res);
        });
        if (res?.data?.step === 1) {
          navigate("/tools/bookkeeper");
        }
        await dispatch<any>(
          getTransactionsTableData({
            page: 1,
            limit: 10,
            transaction_type: value === 0 ? 2 : 1,
            filter_by_category: 0,
            start_date: "",
            end_date: "",
            search: "",
          })
        ).then(async (res: any) => {
          setData(res?.payload?.data?.summary);
          setReAuthBanks(res?.payload?.data?.banks_needing_reauth || []);
          if (res?.payload?.data?.banks_needing_reauth?.length) {
            const banks = res?.payload?.data?.banks_needing_reauth;

            // If any bank has needs_reauth === false → show modal
            const shouldOpenReconnectModal = banks.some(
              (bank: any) => bank.is_flagged === false
            );

            if (shouldOpenReconnectModal) {
              // Collect all IDs
              const bankIds = banks.map((bank: any) => bank.plaid_item_id);
              await dispatch<any>(flagBanks({ bankIds: bankIds }));
              setopenReconnectModal(true);
            }
          }
        });
      } catch (error: any) {
        console.log(error.response?.data?.error || error.message);
      }
    };

    transcationData();
  }, [isDelete]);

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      const target = event.target as HTMLElement;

      // ✅ Ignore clicks inside DatePicker popup
      if (target.closest(".MuiPickersPopper-root")) {
        return;
      }

      // ✅ Ignore clicks inside MUI Menu (Category dropdown)
      if (target.closest(".MuiPopover-root")) {
        return;
      }

      // ✅ Close only if click is outside the filter container
      if (filterRef.current && !filterRef.current.contains(target)) {
        setFilterOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  useEffect(() => {
    const timer = setTimeout(() => {
      setLoading(false);
    }, 2000);
    return () => clearTimeout(timer);
  }, [data]);

  const config = {
    token: reAuthToken! || linkToken!,
    onSuccess: async (public_token: string, metaData: any) => {
      setLoading(true);
      await dispatch<any>(userExchangeToken({ public_token })).unwrap();
      await dispatch<any>(getTransactionsStatus()).unwrap();
      setShouldOpenPlaid(false);
      window.location.reload();
    },
    onExit: () => {
      setShouldOpenPlaid(false);
      setAddbankLoading(false);
    },
  };

  const { open, ready } = usePlaidLink(config);

  if (shouldOpenPlaid && ready && reAuthToken) {
    //setopenReconnectModal(false);
    setAddbankLoading(true);
    open();
    // setShouldOpenPlaid(false); // reset after opening
  }

  const handleDelete = (value: boolean) => {
    setIsDelete(value);
  };

  const handleChange = (event: React.SyntheticEvent, newValue: number) => {
    setValue(newValue);
  };

  const connectedBanks = banks?.connected_banks?.filter(
    (item: any) => item?.needs_reauth === false
  );

  if (loading) {
    return <ListLoadingNew />;
  }

  return (
    <div style={{ position: "relative" }}>
      <div
        style={{
          display: isMobile ? "grid" : "flex",
          justifyContent: "space-between",
          alignItems: "center",
          borderRadius: "8px",
          marginBottom: "16px",
          gap: 5,
        }}
      >
        <div
          style={{
            fontSize: isMobile ? "18px" : "24px",
            fontWeight: "500",
            color: "#060110",
          }}
        >
          Business Finances Overview
        </div>
        <div
          style={{
            display: "flex",
            alignItems: "center",
            flexWrap: "wrap",
            gap: 20,
          }}
        >
          <Button
            style={{
              display: "flex",
              alignItems: "center",
              gap: 10,
              background: "linear-gradient(to right, #2977CC, #1D538F)",
              fontWeight: 600,
              fontSize: "14px",
              color: "#ffffff",
              paddingTop: "10px",
              paddingBottom: "10px",
              paddingLeft: "20px",
              paddingRight: "20px",
              width: "fit-content",
            }}
            onClick={() => navigate("/tools/bookkeeper/rules")}
          >
            Rules
          </Button>
          <div style={{ display: "flex", alignItems: "center", gap: 20 }}>
            <div
              ref={filterRef}
              style={{
                position: "relative",
                width: isMobile ? "100%" : "auto",
              }}
            >
              <Button
                style={{
                  display: "flex",
                  alignItems: "center",
                  border: "1px solid #A7C7EA",
                  borderRadius: "8px",
                  height: "40px",
                  padding: "22px 20px",
                  color: "#2C3034",
                  fontSize: "14px",
                  fontWeight: 500,
                  gap: 10,
                }}
                onClick={(e) => {
                  setFilterOpen(!filterOpen);
                  setAnchorEl(e.currentTarget);
                }}
              >
                {connectedBanks?.length || 0}{" "}
                {connectedBanks?.length === 1 ? "Bank" : "Banks"} Connected
                <span
                  style={{
                    borderLeft: "2px solid #EAF1FA",
                    paddingLeft: "16px",
                    marginLeft: "10px",
                    paddingTop: "9px",
                  }}
                >
                  <DownArrowIcon />
                </span>
              </Button>
              {filterOpen && (
                <Box
                  sx={{
                    position: "absolute",
                    top: "calc(100% + 8px)",
                    left: isMobile ? "8px" : "auto",
                    right: isMobile ? "8px" : 0,
                    width: isMobile ? "calc(100vw - 16px)" : "320px",
                    zIndex: 1400,
                  }}
                >
                  <ConnectionDropdown
                    anchorEl={anchorEl}
                    onClose={() => setAnchorEl(null)}
                    connectedBanks={banks?.connected_banks || []}
                    disconnectedBanks={banks?.disconnected_banks || []}
                    onDisconnect={() => setopenCategoryModal(true)}
                    onReconnect={handleReconnect}
                    setSelectedBank={setSelectedBank}
                    setLoading={setLoading}
                  />
                </Box>
              )}
            </div>
          </div>
          <Button
            style={{
              display: "flex",
              alignItems: "center",
              gap: 10,
              background: isFetching
                ? "#BDBDBD"
                : "linear-gradient(to right, #2977CC, #1D538F)",
              fontWeight: 600,
              fontSize: "12px",
              color: "#ffffff",
              paddingTop: "12px",
              paddingBottom: "12px",
              paddingLeft: "20px",
              paddingRight: "20px",
              width: "fit-content",
            }}
            onClick={async () => {
              setIsFetching(true);
              await dispatch<any>(fetchASync())
                .then(async (res: any) => {
                  await dispatch<any>(getBanksLists()).then((resp: any) => {
                    setBanks(resp?.payload?.data);
                  });
                  if (res?.payload?.data?.banks_needing_reauth?.length) {
                    setReAuthBanks(
                      res?.payload?.data?.banks_needing_reauth || []
                    );
                    setopenReconnectModal(true);
                    return;
                  }
                  await dispatch<any>(
                    getTransactionsTableData({
                      page: 1,
                      limit: 10,
                      transaction_type: value === 0 ? 2 : 1,
                      filter_by_category: 0,
                      start_date: "",
                      end_date: "",
                      search: "",
                    })
                  ).then((res: any) => {
                    setData(res?.payload?.data?.summary);
                  });
                  dispatch<any>(
                    setToast({
                      message:
                        res?.payload?.message || "Data synced successfully.!",
                      type: "success",
                      title: "Success",
                      onClose: () => {},
                    })
                  );
                })
                .catch((err: any) => {
                  dispatch<any>(
                    setToast({
                      message: err?.payload?.message || "Something went wrong!",
                      type: "error",
                      title: "Error",
                      onClose: () => {},
                    })
                  );
                })
                .finally(() => setIsFetching(false));
            }}
          >
            {!isFetching && <RefreshIcon />}
            {isFetching ? "Fetching..." : " Fetch Latest Data"}
          </Button>
        </div>
      </div>
      <div
        style={{ marginTop: "25px", overflow: "auto", paddingBottom: "8px" }}
      >
        {/**Cards */}
        <Box
          sx={{
            display: "flex",
            flexDirection: isMobile ? "column" : "row",
            gap: isMobile ? 2 : 3,
            width: "100%",
          }}
        >
          <BookkeeperCard
            title="Net Profit"
            price={data?.net_amount || 0}
            icon={<NetProfit />}
            loading={!true}
          />
          <BookkeeperCard
            title="Income"
            price={data?.total_received || 0}
            icon={<IncomeIcon />}
            loading={!true}
          />
          <BookkeeperCard
            title="Expenses"
            price={data?.total_paid || 0}
            icon={<ExpensesIcon />}
            loading={!true}
          />
        </Box>
      </div>
      <Box sx={{ width: "100%" }}>
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            flexWrap: { xs: "wrap", md: "nowrap" }, // wrap only on mobile
            gap: 2,
          }}
        >
          <Tabs
            value={value}
            onChange={handleChange}
            aria-label="basic tabs example"
            variant="scrollable"
            scrollButtons={false}
            sx={{
              borderBottom: 1,
              borderColor: "divider",
              order: { xs: 1, md: 1 }, // stay first in both
              width: { xs: "100%", md: "auto" }, // full width on mobile
            }}
          >
            <Tab
              label="Expenses"
              {...a11yProps(0)}
              sx={{
                mx: 3,
                textTransform: "none",
                fontSize: "16px",
                fontWeight: 600,
              }}
            />
            <Tab
              label="Income"
              {...a11yProps(1)}
              sx={{
                mx: 3,
                textTransform: "none",
                fontSize: "16px",
                fontWeight: 600,
              }}
            />
            <Tab
              label="Balance Sheet"
              {...a11yProps(2)}
              sx={{
                mx: 3,
                textTransform: "none",
                fontSize: "16px",
                fontWeight: 600,
              }}
            />
          </Tabs>

          <Box
            sx={{
              display: "flex",
              justifyContent: { xs: "flex-end", md: "flex-end" },
              width: { xs: "100%", md: "auto" }, // full width on mobile so it goes to next line
              order: { xs: 2, md: 2 },
              mt: { xs: 1, md: 0 }, // small margin on mobile
            }}
          >
            <button
              style={{
                fontSize: "12px",
                fontWeight: 600,
                color: "#FFFFFF",
                padding: "12px 24px",
                background: addbankLoading ? "#ccc" : "#2977CC",
                borderRadius: "8px",
                border: "none",
                cursor: addbankLoading ? "not-allowed" : "pointer",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                gap: "10px",
              }}
              onClick={handleClick}
            >
              <AddBankIcon />
              Add Banks
            </button>
          </Box>
        </Box>

        <CustomTabPanel value={value} index={0}>
          <BookkeeperTable
            title={"Expenses"}
            value={value}
            isDelete={handleDelete}
            setData={setData}
          />
        </CustomTabPanel>
        <CustomTabPanel value={value} index={1}>
          <BookkeeperTable
            title={"Income"}
            value={value}
            isDelete={handleDelete}
            setData={setData}
          />
        </CustomTabPanel>
        <CustomTabPanel value={value} index={2}>
          <BookkeeperBalanceSheet val={setData} />
        </CustomTabPanel>
      </Box>

      {/** Reconnect Bank Modal */}
      <Modal
        open={openReconnectModal}
        onClose={() => {
          setopenReconnectModal(false);
        }}
      >
        <ModalWrapper
          sx={{
            width: isMobile ? "350px" : "500px",
            p: 0,
            height: "fit-content",
            backgroundImage: "none",
            position: "relative",
            borderRadius: "20px",
            overflow: "hidden",
            outline: "none",
          }}
        >
          {/* Top right decoration */}
          <div
            style={{
              position: "absolute",
              top: 0,
              right: 0,
              zIndex: 1,
            }}
          >
            <ModalTop />
          </div>
          {/* Bottom left decoration */}
          <div
            style={{
              position: "absolute",
              bottom: -6,
              left: 0,
              zIndex: 1,
            }}
          >
            <ModalBottom />
          </div>
          {/* Ensure close button is above decorations */}
          <CloseButtonWrapper
            sx={{ zIndex: 10, position: "relative", marginTop: 1 }}
          >
            <CloseButton onClick={() => setopenReconnectModal(false)}>
              <CrossIcon />
            </CloseButton>
          </CloseButtonWrapper>
          <Box sx={{ p: 4, pt: 0 }}>
            {/* Trash icon with red bg */}
            <Box
              sx={{ display: "flex", justifyContent: "center", mt: 1, mb: 2 }}
            >
              <Box
                sx={{
                  background: "#EAF1FA",
                  borderRadius: "50%",
                  p: 2.5,
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                }}
              >
                <ReconnectBankIcon />
              </Box>
            </Box>
            <div
              style={{
                textAlign: "center",
                fontSize: isMobile ? "20px" : "24px",
                color: "#01060B",
                fontWeight: 700,
                marginTop: 0,
                marginBottom: 10,
              }}
            >
              Reconnect Your Bank Accounts
            </div>
            <div
              style={{
                width: isMobile ? "100%" : "350px",
                textAlign: "center",
                lineHeight: "24px",
                margin: "0 auto",
                fontSize: isMobile ? "12px" : "16px",
                color: "#6C6F71",
                fontWeight: 500,
                fontFamily: "Plus Jakarta Sans",
                paddingBottom: "5px",
                paddingTop: "5px",
              }}
            >
              We’re unable to fetch your transactions from these{" "}
              {reAuthBanks?.length} banks. Reconnect them to keep your data up
              to date.
            </div>
            {reAuthBanks?.length > 0 && (
              <Box
                sx={{
                  display: "flex",
                  flexDirection: "column",
                  gap: 2,
                  mt: 3,
                  mb: 4,
                  justifyContent: "center",
                  width: "100%",
                  background: "#EAF1FA80",
                  padding: "27px 30px",
                  borderRadius: "12px",
                }}
              >
                {reAuthBanks?.map((bank: any) => (
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "space-between",
                      textAlign: "center",
                    }}
                  >
                    <div
                      style={{ display: "flex", alignItems: "center", gap: 0 }}
                    >
                      <div
                        style={{
                          backgroundColor: "#fff",
                          borderRadius: "100px",
                          marginRight: "12px",
                          width: "44px",
                          height: "44px",
                          border: `1px solid #EAF1FA`,
                          textAlign: "center",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                        }}
                      >
                        <BankBlueIcon />
                      </div>
                      <div>{bank?.institution_name}</div>
                    </div>
                    <Button
                      sx={{
                        backgroundColor: "#fff",
                        border: "1px solid #D88150",
                        borderRadius: "8px",
                        width: "120px",
                        height: "35px",
                        fontSize: "14px",
                        fontWeight: 500,
                        color: "#D88150",
                        mt: 1,
                      }}
                      onClick={async (e) => {
                        e.preventDefault();
                        setSelectedBank(bank);
                        handleReconnect(bank, true);
                        setopenReconnectModal(false);

                        // Step 3 — open Plaid after modal unmounts
                        setTimeout(() => {
                          setShouldOpenPlaid(true);
                        }, 100); // 300ms delay to let modal fully close
                      }}
                    >
                      Reconnect
                    </Button>
                  </div>
                ))}
              </Box>
            )}
          </Box>
        </ModalWrapper>
      </Modal>

      {/** Disconnect Bank Modal */}
      <Modal
        open={openCategoryModal}
        onClose={() => {
          setopenCategoryModal(false);
        }}
      >
        <ModalWrapper
          sx={{
            width: isMobile ? "350px" : "500px",
            p: 0,
            height: "370px",
            backgroundImage: "none",
            position: "relative",
            borderRadius: "20px",
            overflow: "hidden",
            outline: "none",
          }}
        >
          {/* Top right decoration */}
          <div
            style={{
              position: "absolute",
              top: 0,
              right: 0,
              zIndex: 1,
            }}
          >
            <ModalTop />
          </div>
          {/* Bottom left decoration */}
          <div
            style={{
              position: "absolute",
              bottom: -6,
              left: 0,
              zIndex: 1,
            }}
          >
            <ModalBottom />
          </div>
          {/* Ensure close button is above decorations */}
          <CloseButtonWrapper
            sx={{ zIndex: 10, position: "relative", marginTop: 1 }}
          >
            <CloseButton onClick={() => setopenCategoryModal(false)}>
              <CrossIcon />
            </CloseButton>
          </CloseButtonWrapper>
          <Box sx={{ p: 4, pt: 0 }}>
            {/* Trash icon with red bg */}
            <Box
              sx={{ display: "flex", justifyContent: "center", mt: 1, mb: 2 }}
            >
              <Box
                sx={{
                  background: "#2977CC36",
                  borderRadius: "50%",
                  p: 3,
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                }}
              >
                <BankBlueIcon />
              </Box>
            </Box>
            <div
              style={{
                textAlign: "center",
                fontSize: isMobile ? "20px" : "24px",
                color: "#01060B",
                fontWeight: 700,
                marginTop: 0,
                marginBottom: 10,
              }}
            >
              Disconnect {selectedBank?.institution_name}?
            </div>
            <div
              style={{
                width: isMobile ? "100%" : "290px",
                textAlign: "center",
                lineHeight: "24px",
                margin: "0 auto",
                fontSize: isMobile ? "12px" : "16px",
                color: "#6C6F71",
                fontWeight: 500,
                fontFamily: "Plus Jakarta Sans",
              }}
            >
              Are you sure you want to <br />
              Disconnect the {selectedBank?.institution_name}?
            </div>
            <Box
              sx={{
                display: "flex",
                gap: 2,
                mt: 3,
                justifyContent: "center",
              }}
            >
              <Button
                sx={{
                  border: "2px solid #2977CC",
                  borderRadius: "8px",
                  width: "192px",
                  height: "51px",
                  fontSize: "16px",
                  fontWeight: 600,
                  color: "#2977CC",
                }}
                onClick={() => {
                  setopenCategoryModal(false);
                }}
              >
                Close
              </Button>
              <Button
                sx={{
                  background: "linear-gradient(to right, #2977CC, #1D538F)",
                  color: "white",
                  width: "192px",
                  height: "51px",
                  fontSize: "16px",
                  fontWeight: 600,
                }}
                onClick={handleDisconnect}
              >
                Yes
              </Button>
            </Box>
          </Box>
        </ModalWrapper>
      </Modal>
    </div>
  );
};

export default BookkeeperData;
